module.exports = __webpack_public_path__ + "infocentrum12.jpg?7410bee248bad81500604ab3e08a8010";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum12.jpg
// module id = 264
// module chunks = 0